<template>
  <div class="operator-schedules">
    <div v-if="schedules && schedules.length" class="list-group">
      <div
        v-for="schedule in schedules"
        :key="schedule.id"
        class="list-group-item list-group-item-action"
      >
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div>
            <h5 class="row no-gutters mb-0">
              <div
                v-if="schedule.assignee"
                :style="{
                  backgroundImage: `url(${staticUrl}${schedule.assignee.photo})`,
                }"
                class="avatar col-auto mr-2"
                :class="{ online: isOnline(schedule.assignee.id) }"
              ></div>
              <div class="col-auto mr-2">
                <div v-if="schedule.assignee">
                  {{ schedule.assignee.firstname[authLocale] }}
                  {{ schedule.assignee.lastname[authLocale] }}
                </div>
                <small class="svg">
                  <online-consultation-icon
                    v-if="schedule.clinic_service.type === 'telemedicine'"
                  ></online-consultation-icon>
                  <clinic-icon
                    v-else-if="schedule.clinic_service.type === 'visit'"
                  ></clinic-icon>
                  <ambulance-icon
                    v-else-if="schedule.clinic_service.type === 'house_call'"
                  ></ambulance-icon>
                  <span>
                    {{ $t(schedule.clinic_service.type) }}
                    {{ schedule.clinic_service.name[authLocale] }}
                  </span>
                </small>
                <small
                  class="d-block"
                  v-if="
                    schedule.clinic_service.type === 'house_call' &&
                    schedule.address
                  "
                >
                  მისამართი: {{ schedule.address }}
                </small>
                <div>
                  <a
                    class="align-items-center svg-sm btn btn-outline-primary btn-sm mt-2"
                    v-if="
                      schedule.interview_id &&
                      schedule.interview_status === 'finished'
                    "
                  >
                    <small class="pr-2">
                      <i class="text-success">
                        <yes-icon></yes-icon>
                      </i>
                    </small>
                    <small>
                      {{ $t("interviewFinished") }}
                    </small>
                  </a>
                  <div
                    class="align-items-center svg-sm btn btn-outline-primary btn-sm mt-2"
                    v-else-if="schedule.interview_id"
                  >
                    <small class="pr-2">
                      <i
                        v-if="
                          schedule.interview_status === 'initiated' ||
                          schedule.interview_status === 'active'
                        "
                        :class="{
                          'text-danger':
                            schedule.interview_status === 'initiated',
                          'text-warning': schedule.interview_status === 'active',
                        }"
                      >
                        <symptom-checker-icon></symptom-checker-icon>
                      </i>
                    </small>
                    <small v-if="schedule.interview_status === 'initiated'">
                      {{ $t("interviewInited") }}
                    </small>
                    <small v-else-if="schedule.interview_status === 'active'">
                      {{ $t("interviewActive") }}
                    </small>
                    <small v-else-if="schedule.interview_status === 'cancelled'">
                      {{ $t("interviewCancelled") }}
                    </small>
                  </div>
                </div>
              </div>
            </h5>
            <h5 class="row no-gutters align-items-center mt-2">
              <div
                v-if="schedule.patient"
                :style="{
                  backgroundImage: `url(${staticUrl}${schedule.patient.photo})`,
                }"
                class="avatar avatar-sm col-auto mr-2"
                :class="{ online: isOnline(schedule.patient.id) }"
              ></div>
              <div class="col-auto mr-2">
                <div v-if="schedule.patient">
                  {{ schedule.patient.firstname[authLocale] }}
                  {{ schedule.patient.lastname[authLocale] }}
                </div>
              </div>
            </h5>
          </div>
          <div>
            <h5 class="text-right mb-0">
              {{ schedule.start_time | moment("HH:mm") }}
              <small class="d-block">
                {{ schedule.start_time | moment("ddd, DD MMMM") }}
              </small>
            </h5>
            <div>
              <a
                href="#"
                class="btn btn-primary btn-sm lowercase"
                @click.prevent="markPaid(schedule.id)"
                v-if="schedule.status === 'payment_required'"
              >
                ადგილზე გადაიხადა
              </a>
            </div>
          </div>
        </div>
      </div>
      <LoadingMore v-if="loading"></LoadingMore>
      <a
        v-else-if="more"
        @click.prevent="loadMore"
        class="pointer d-block bg-primary text-white text-center py-2"
      >
        <small>{{ $t("loadMore") }}</small>
      </a>
    </div>
  </div>
</template>
<script>
import LoadingMore from '@/components/Loadings/More'
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
import YesIcon from '@/components/Icons/Yes'
import SymptomCheckerIcon from '@/components/Icons/SymptomChecker'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    LoadingMore,
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon,
    YesIcon,
    SymptomCheckerIcon
  },
  data () {
    return {
      loading: false,
      offset: 0,
      limit: 10,
      more: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      isOnline: 'status/isOnline',
      schedules: 'schedule/schedulesAsc',
      scrolledToBottom: 'app/scrolledToBottom'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset',
      setAlert: 'alert/setAlert'
    }),
    init () {
      this.resetSchedule()
      this.fetchSchedules()
    },
    loadMore () {
      this.offset = this.limit + this.offset
      this.fetchSchedules()
    },
    async fetchSchedules () {
      this.loading = true
      const params = {
        offset: this.offset,
        limit: this.limit,
        from: this.$moment().startOf('day').format(),
        to: this.$moment().add(30, 'days').format()
      }
      try {
        const response = await this.axios.get('/api/schedules', {
          params
        })
        const schedules = response.data.data
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
        }
        if (schedules.length < this.limit) {
          this.more = false
        }
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async markPaid (id) {
      try {
        const response = await this.axios.post(
          `/api/schedules/${id}/mark-paid`,
          {}
        )
        const schedule = response.data.data
        this.setSchedule({
          id: schedule.id,
          city_id: schedule.city_id,
          address: schedule.address,
          patient_id: schedule.patient_id,
          patient: schedule.patient,
          clinic_service_id: schedule.clinic_service_id,
          clinic_service: schedule.clinic_service,
          clinic_id: schedule.clinic_id,
          service_id: schedule.service_id,
          assignee_id: schedule.assignee_id,
          assignee: schedule.assignee,
          communication_days: schedule.communication_days,
          start_time: schedule.start_time,
          status: schedule.status,
          price: schedule.price,
          comment: schedule.comment,
          interview_id: schedule.interview_id,
          interview_status: schedule.interview_status,
          patient_case_id: schedule.patient_case_id,
          created_at: schedule.created_at,
          created_by: schedule.created_by
        })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.operator-schedules {
  .service-item {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .dates {
    font-size: 0.75em;
    background: #3c88ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    // position: sticky;
    // top: 0;
    // z-index: 200;
    color: #fff;
    .first {
      transform: rotate(180deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .prev {
      transform: rotate(90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .next {
      transform: rotate(-90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "createSchedule": "ჩანიშვნა",
      "cancel": "გაუქმება",
      "createCase": "ქეისის შექმნა",
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "attachCase": "ქეისზე მიმაგრება",
      "interviewInited": "კითხვარი არ არის შევსებული",
      "interviewActive": "კითხვარი დაუსრულებელია",
      "interviewFinished": "კითხვარი დასრულებულია",
      "interviewCancelled": "კითხვარი გაუქმებულია"
  }
}
</i18n>
